import SuccessGooglePay from "@/views/public/success/google/SuccessGooglePay.vue";

export default {
  path: "/success-googlepay",
  name: "successGooglePay",
  component: SuccessGooglePay
};
